import React from 'react'
import { FaFlag, isEmpty } from '@fareye/utils'
import { Flex } from '../../main'
import Commenting from '../components/Commenting'
import Download from '../components/Download'
import Refresh from '../components/Refresh'
import { TableAction } from '../styled'
import { ITableActions } from '../types'
import SelectedFilterListing from '../components/SelectedFilterListing'

function TableActions(props: ITableActions) {
  const {
    refresh,
    refreshing,
    refreshLabel,
    downloadCSV,
    downloadLabel,
    totalElements,
    toggleFlagging,
    showTotalCount,
    downloadTitle,
    downloadLoading,
    downloadDisabled,
    selectedFilters,
    setSelectedFilters,
    commentingModule,
    issueLabel,
    totalCountText,
    t
  } = props
  const Flagging = () => {
    return toggleFlagging ? (
      <FaFlag
        style={{ color: '#00a4ff', margin: '0 15px' }}
        size={18}
        onClick={toggleFlagging}
      />
    ) : null
  }
  const totalCountWholeString = `${
    t ? t(totalCountText) : totalCountText || t ? t('Total') : 'Total'
  } ${totalElements || '-'}`
  return (
    <TableAction
      data-testid={`table-actions`}
      justifyContentSpaceBetween
      alignItemsCenter
    >
      <Flex
        data-testid={`total-elements`}
        alignItemsCenter
        style={{ marginLeft: 5 }}
      >
        {showTotalCount
          ? t
            ? t(totalCountWholeString)
            : totalCountWholeString
          : null}
      </Flex>
      <Flex style={{ fontSize: '10px', flex: '1 0 100px', overflow: 'hidden' }}>
        <Flex
          alignItemsFlexStart
          style={{ flex: '1 0 100px', overflow: 'hidden' }}
        >
          {!isEmpty(selectedFilters) ? (
            <SelectedFilterListing
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
            />
          ) : null}
        </Flex>
        <Flex alignItemsCenter>
          <Refresh
            refreshing={refreshing}
            refresh={refresh}
            refreshLabel={refreshLabel}
          />
          <Commenting
            commentingModule={commentingModule}
            issueLabel={issueLabel}
          />
          <Flagging />
          <Download
            downloadCSV={downloadCSV}
            downloadLabel={downloadLabel}
            downloadTitle={downloadTitle}
            downloadLoading={downloadLoading}
            downloadDisabled={downloadDisabled}
          />
        </Flex>
      </Flex>
    </TableAction>
  )
}

export default TableActions
